import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormArray,FormGroup,FormControl,Validators,NgForm } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { sessionService } from '../../service/session.service';
import { HttpErrorResponse } from '@angular/common/http';
import {NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import {commonService} from "../../service/common.service";
import { scheduleService } from '../../service/schedule.service';

@Component({
  selector: 'app-addstreammpg',
  templateUrl: './addstreammpg.component.html',
  styleUrls: ['./addstreammpg.component.css'],
  providers:[sessionService,commonService,scheduleService]
})
export class AddstreammpgComponent implements OnInit {
  public addstreammappingForm: FormGroup;
  formvailidation=false;
  msg:any;
  isSuccess=false;
  isError=false;
  mapping:any;
  mappingId:any;
  subjectbox:any;
  streambox:any;
  constructor(public router: Router,private _schedule:scheduleService,private commonService:commonService,private _session:sessionService,private frmBuilder: FormBuilder,private route: ActivatedRoute) { 
    this.mapping = {
      stream:'',
      Subject:'',
      Status:''
     }
  }

  ngOnInit() {
    this.getstreamtype('');
    this.getsubject('');
    this.route.queryParams.subscribe(params => { 
      if(params['cid']){
        this.mappingId = atob(params['cid']);
        this._schedule.getstreammpg(this.mappingId).subscribe((data : any)=>{
          if(data.error==0){ 
            
             // load session drop box
            // this.onChangeSession('',data.results.centerId);
            this.mapping = {
              stream:data.results.streamId,
              Subject:data.results.subjectId,
              Status:data.results.status,
            }
          }else{
            if(data.message=="Failed to authenticate token."){
              this.router.navigate(['/admin']);
            }else{
            this.msg = data.message;
            this.isError = true;
            }
          }

        });

      }
  }); 
  }

  register(addstreammappingForm) {
    addstreammappingForm.value.userid=this.commonService.user.id;
  console.log(addstreammappingForm.value);
  if(addstreammappingForm.status=="INVALID"){
   this.formvailidation=true;
  }else{
   this.formvailidation=false;
   if(this.mappingId){
            this._schedule.editstreammpg(addstreammappingForm.value,this.mappingId).subscribe((data : any)=>{
              if(data.error==0){  
                localStorage.setItem('isSuccess','Yes');
                localStorage.setItem('msg','Stream Mapping updated successfully.');
                this.router.navigate(['/admin/discussion/viewstreammpg']);
              }else{
                if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
                }else{
                this.msg = data.message;
                this.isError = true;
                }
              }
          },
        (error : HttpErrorResponse)=>{
          this.isError = true;
          this.msg="internal server error!";
        });
   }else{
        this._schedule.addstreammpg(addstreammappingForm.value).subscribe((data : any)=>{
              if(data.error==0){ 
                localStorage.setItem('isSuccess','Yes');
                localStorage.setItem('msg','Stream Mapping added successfully.');
                this.router.navigate(['/admin/discussion/viewstreammpg']);
              }else{
                if(data.message=="Failed to authenticate token."){
                  this.router.navigate(['/admin']);
                }else{
                this.msg = data.message;
                this.isError = true;
                }
              }
          },
              (error : HttpErrorResponse)=>{
                this.isError = true;
                this.msg="internal server error!";
              });
            }
  }
}
  

  getsubject(subjectId){
    this._session.usersubject(subjectId).subscribe((data : any)=>{     
      if(data.error==0){ 
        
        this.subjectbox = data.results;   
      }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/admin']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
  },
  (error : HttpErrorResponse)=>{
   this.isError = true;
   this.msg="internal server error!";
  });  
  
  }

  getstreamtype(streamtypeId){
    this._session.userstream(streamtypeId).subscribe((data : any)=>{     
      if(data.error==0){ 
        this.streambox= data.results;   
      }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/admin']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
  },
  (error : HttpErrorResponse)=>{
   this.isError = true;
   this.msg="internal server error!";
  });    
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/addstreammpg/addstreammpg.component.ts